import React from 'react';

/**
 * Proposed glyph for the uptime check — the brand mark's signal arc,
 * repeated outward from a transmitting point.
 */
export function SignalArc({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" focusable="false" data-id="element-238" data-mp="1xl65wnne5od5">
      <circle cx="12" cy="19.2" r="1.7" fill="currentColor" data-id="element-239" data-mp="1smmieit5g4io" />
      <path d="M8.8 16.6a4.6 4.6 0 0 1 6.4 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" data-id="element-240" data-mp="14xaenyglconr" />
      <path d="M6.2 13.6a8.2 8.2 0 0 1 11.6 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" opacity="0.75" data-id="element-241" data-mp="10sklihdbho6j" />
      <path d="M3.8 10.8a11.8 11.8 0 0 1 16.4 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" opacity="0.45" data-id="element-242" data-mp="19tsgoqkje8we" />
    </svg>;
}